import { defaultMappingByComponent, mappingByType } from './definitions';

export const getComponentByType = ({ components, type }) => {
  const { component, props } = mappingByType[type];

  return {
    Component: components[component] || defaultMappingByComponent[component],
    props
  };
};
